import { Input, SimpleGrid, Button,Divider } from "@chakra-ui/react";
import React, { useEffect, useState, useCallback } from "react";
import Token from "../../config/token";
import { Operations } from "./Operations/Operations";
import NewUsers from "../Summaries/NewUsers";
import Sells from "../Summaries/Sells";
import TotalPackages from "../Summaries/TotalPackages";
import moment from "moment";
import { toast } from "react-toastify";
import { summaryApi } from "../../api";

export const Dashboard = () => {
  const [role, setRole] = useState(false);
  const [dates, setDates] = useState({
    start: moment().startOf("year").format("YYYY-MM-DD"), // 1 de enero del año actual
    end: moment().format("YYYY-MM-DD"), // Hoy
  });

  const [searchDates, setSearchDates] = useState(dates);
  const [sells, setSells] = useState([]);

  // Cargar rol del usuario
  useEffect(() => {
    const userRole = Token.check()?.sub?.roles?.[0]?.name || false;
    setRole(userRole);
  }, []);

  // Obtener ventas basado en la fecha seleccionada
  useEffect(() => {
    if (dates.start && dates.end) {
      summaryApi.allSells(dates.start, dates.end).then((response) => {
        setSells(response.data.data);
      });
    }
  }, [dates]);

  // Manejo de input para fechas
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setSearchDates((prev) => ({ ...prev, [name]: value }));
  };

  // Aplicar búsqueda
  const onSearch = useCallback(() => {
    setDates(searchDates);
    toast.info("...Buscando", { theme: "dark", autoClose: 1000 });
  }, [searchDates]);

  const renderWidget = () => {
    let widget = document.getElementById(
      "coinmarketcap-widget-marquee"
    ).innerHTML;

    widget = widget.replaceAll('style="display: none;"', "");

    console.log(widget);
    return <div dangerouslySetInnerHTML={{ __html: widget }}></div>;
  };

  return (
    <>
      {/* ✅ CoinMarketCap Widget */}
      <SimpleGrid columns={1} spacing={10}>
      {renderWidget()}
    </SimpleGrid>
    <Divider my={9}  />


    <SimpleGrid columns={3} spacing={10}>
  <Input
    name="start"
    placeholder="Fecha inicio"
    size="md"
    type="date"
    value={searchDates.start}
    onChange={handleDateChange}
    color="white"
    borderColor="white"
    _placeholder={{ color: "gray.400" }}
    sx={{
      "&::-webkit-calendar-picker-indicator": {
        filter: "invert(1)", // Hace el icono blanco
      },
    }}
  />
  <Input
    name="end"
    placeholder="Fecha fin"
    size="md"
    type="date"
    value={searchDates.end}
    onChange={handleDateChange}
    color="white"
    borderColor="white"
    _placeholder={{ color: "gray.400" }}
    sx={{
      "&::-webkit-calendar-picker-indicator": {
        filter: "invert(1)", // Hace el icono blanco
      },
    }}
  />
  <Button
    style={{
      marginBottom: "10px",
      color: "white",
      marginTop: "10px",
      backgroundColor: "#f7931a",
    }}
    onClick={onSearch}
  >
    Buscar
  </Button>
</SimpleGrid>


      {/* ✅ Datos resúmenes */}
      <SimpleGrid marginTop="16px" columns={3} spacing={10}>
        <NewUsers start={dates.start} end={dates.end} />
        <Sells start={dates.start} end={dates.end} />
        <TotalPackages start={dates.start} end={dates.end} />
      </SimpleGrid>

      <Divider my={9}  />
      <Operations />
    </>
  );
};
